import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteClef } from "../api/CLEF/clef";

export function useDeleteApiKey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteClef,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["api-keys"] });
    },
  });
}
